import { SettingsEndpoint } from "@constants/ApiEndpoints";
import { AxiosInstance } from "axios";
import { SeasonModel } from "models/Settings/RatesAndPromo/SeasonModel";
import { FetchingRequestParamsModels } from "models/Shared/FetchingRequestParamsModels";

export const remove =
  (axios: AxiosInstance) =>
  async (id: number): Promise<SeasonModel> => {
    return await axios.delete(
      `${SettingsEndpoint.SETTINGS_RATES_SEASON}/${id}`
    );
  };

export const getAll =
  (axios: AxiosInstance) =>
  async (params?: FetchingRequestParamsModels): Promise<SeasonModel[]> => {
    return await axios
      .get(SettingsEndpoint.SETTINGS_RATES_SEASON, {
        params,
      })
      .then(({ data }) => data.items);
  };

export const create =
  (axios: AxiosInstance) =>
  async (data: SeasonModel): Promise<SeasonModel> => {
    return await axios
      .post(SettingsEndpoint.SETTINGS_RATES_SEASON, data)
      .then(({ data }) => data);
  };

export const update =
  (axios: AxiosInstance) =>
  async (data: SeasonModel): Promise<SeasonModel> => {
    return await axios
      .put(`/${SettingsEndpoint.SETTINGS_RATES_SEASON}/${data.id}`, data)
      .then(({ data }) => data);
  };

export const toggleStatus =
  (axios: AxiosInstance) =>
  async (id: number): Promise<SeasonModel> => {
    return await axios
      .patch(`/${SettingsEndpoint.SETTINGS_RATES_SEASON}/${id}`)
      .then(({ data }) => data);
  };
